import {Component, OnDestroy, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {DataManagementService} from '../../services/data-management.service';
import {BiddingService} from '../../services/bidding.service';
import {Router} from '@angular/router';
import {EpasUtilService} from '../../services/epas-util.service';
import {AuthenticationService} from '../../services/authentication.service';
import {ToastrService} from 'ngx-toastr';
import {RoundNameConstants} from '../../round-name-constants';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import {Constants} from '../../constants';
import {NgbModal, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-confirmation-round-two',
    templateUrl: '../confirmation-practice-round/confirmation-practice-round.component.html',
    styleUrls: ['../confirmation-practice-round/confirmation-practice-round.component.css']
})
export class ConfirmationRoundTwoComponent implements OnInit, OnDestroy {
    @ViewChild('changeDreamUniversityModal') changeDreamUniversityModal: TemplateRef<any>;
	isPracticeConfirmationRound = false;
	isDreamUniversityEnabled = true;
    isConfirmationRoundOne = false;
    isConfirmationRoundTwo = true;
    isConfirmationRoundThree = false;
    enableOptOut = true;
    timeToEnd;
    timeToStart;
    roundSettingsTimer;
    oneSecondTimer;
    inRandomTime = false;
    isRoundEnded = false;
    isRoundYetToStart = false;
    isDataReady = false;
    isRoundExist = false;
    errorMessage: string = undefined;
    currentTime;
    currentTimeStr: string;
    route;
    startTime;
    startTimeStr: string;
    endTime;
    endTimeStr: string;
    refID;
    finalEndTime;
    activeRoundLink: string;
    activeRound: string;
    title = 'Confirmation Round 2';
    winningUniversity;
    termUniversities;
    confirmedUniversity;
    isStudentRoundDataReady = false;
    isDataFetched = false;
    term;
    selectUndefinedOptionValue = 0;
    universities;
    dreamUniversity;
    isUniversityAllotted = false;
    isStudentOptedOutFromExchange = false;
    roundName = 'Confirmation round 2';
    public modalReference: NgbModalRef;
    changedDreamUniversity;
    optingOut;

    constructor(private dmService: DataManagementService,
                private biddingService: BiddingService,
                private router: Router,
                private utilService: EpasUtilService,
                private authService: AuthenticationService,
                private modal: NgbModal,
                private toastr: ToastrService) {
    }

    refreshRoundSettings() {
        if (this.utilService.term !== undefined && this.utilService.term !== null && this.utilService.term !== '') {
            if (this.utilService.term.hasOwnProperty('rounds') && this.utilService.term.rounds
                .hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND2)) {
                this.startTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].start_time)
                    .utcOffset('+05:30');
                this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                this.endTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time).utcOffset('+05:30');
                this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                this.finalEndTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time)
                    .utcOffset('+05:30').add(this.refID, 'seconds');
                this.isRoundExist = true;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
            }
        }
    }

    getRoundData(): void {
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const loggedInStudent = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            if (JSON.parse(localStorage.getItem('epas_user')).term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND2)) {
                const roundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
                    .outgoing_round_id;
                let previousRoundId = 0;
                if (JSON.parse(localStorage.getItem('epas_user')).term.rounds.hasOwnProperty(RoundNameConstants.BIDDING_ROUND_TWO)) {
                    previousRoundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.BIDDING_ROUND_TWO]
                        .outgoing_round_id;
                }
                const focusedElement: HTMLElement = <HTMLElement>document.activeElement;
                this.dmService.getDynamicDataForConfirmationRound(loggedInStudent, roundId, previousRoundId, 2)
                    .subscribe(
                        details => {
                            this.isRoundExist = true;
                            this.isUniversityAllotted = false;
                            if (details.status === 'success') {
                                this.winningUniversity = details.data.winning_university;
                                this.confirmedUniversity = details.data.confirmed_university;
                                this.isUniversityAllotted = details.data.is_university_allotted;
                                this.isStudentOptedOutFromExchange = details.data.is_student_opted_out;
                                this.universities = details.data.all_universities;
                                this.dreamUniversity = details.data.dream_university;
                                if (focusedElement.id !== undefined && focusedElement.id !== '' && focusedElement.id !== null) {
                                    window.setTimeout(function () {
                                        document.getElementById(focusedElement.id).focus();
                                    }, 0);
                                }
                                this.isStudentRoundDataReady = true;
                            } else if (details.status === 'fail' && details.name === 'SequelizeConnectionError') {
                                Swal({type: 'error', title: 'There\'s a problem with your internet connection'});
                            } else if (details.status === 'fail') {
                                this.errorMessage = details.message;
                            }
                        },
                        error => {
                            console.log(error);
                            this.errorMessage = 'Server Error';
                            this.isStudentRoundDataReady = true;
                            this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                                ' the issue persists', 'Fail');
                        });
            } else {
                this.isRoundExist = false;
                this.isStudentRoundDataReady = true;
            }
        }
    }

    getRoundTimings(): void {
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null) {
            const loggedInStudent = JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id;
            if (JSON.parse(localStorage.getItem('epas_user')).term.hasOwnProperty('rounds') &&
                JSON.parse(localStorage.getItem('epas_user')).term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND2)) {
                this.utilService.refreshTerm(loggedInStudent).subscribe(roundDetails => {
                    if (roundDetails.status === 'success') {
                        if (roundDetails.data != null) {
                            this.utilService.term = {rounds: roundDetails.data.rounds};
                            this.utilService.term.currentTime = roundDetails.data.current_time;
                            this.utilService.term.registration_start_time = roundDetails.data.term.registration_start_time;
                            this.utilService.term.registration_end_time = roundDetails.data.term.registration_end_time;

                            this.currentTime = moment(roundDetails.data.current_time).utcOffset('+05:30');
                            this.startTime = moment(roundDetails.data.rounds[RoundNameConstants.CONFIRMATION_ROUND2].start_time)
                                .utcOffset('+05:30');
                            this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                            this.endTime = moment(roundDetails.data.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time)
                                .utcOffset('+05:30');
                            this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                            this.finalEndTime = moment(roundDetails.data.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time)
                                .utcOffset('+05:30').add(this.refID, 'seconds');
                        }
                        this.isRoundExist = true;
                        const user = JSON.parse(localStorage.getItem('epas_user'));
                        user.term.rounds = roundDetails.data.rounds;
                        this.authService.setUser(JSON.stringify(user));
                    } else if (roundDetails.status === 'fail' && roundDetails.data.name === 'SequelizeConnectionError') {
                        Swal({type: 'error', title: 'There\'s a problem with your internet connection'});
                    } else if (roundDetails.status === 'fail') {
                        Swal({type: 'warning', title: 'Application updated', text: roundDetails.data.message});
                        this.errorMessage = roundDetails.data.message;
                    }
                }, error => {
                    this.toastr.warning('Something is not right. Please refresh and reach out to contact team if' +
                        ' the issue persists', 'Fail');
                    console.log(error);
                    this.isDataReady = true;
                    this.errorMessage = 'Server Error';
                });
            } else {
                this.isRoundExist = false;
                this.isDataReady = true;
            }
        }
    }

    closeModal(): void {
        this.changedDreamUniversity = undefined;
        this.modalReference.close();
    }

    openChangeDreamUniversityModal(): void {
        this.modalReference = this.modal.open(this.changeDreamUniversityModal, {size: 'lg', backdrop: 'static', keyboard: false});
	}

	disableDreamChange(): boolean {
		const currentRoundId = JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
			.outgoing_round_id;
		return (this.dreamUniversity !== null && this.dreamUniversity.hasOwnProperty('outgoing_round_id') && this.dreamUniversity.outgoing_round_id !== currentRoundId);
	}

    changeDreamUniversity(e) {
		e.preventDefault();
        const that = this;
        let changeDreamUniversityResponse;
        const body = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_name_id: RoundNameConstants.CONFIRMATION_ROUND2,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
                .outgoing_round_id,
            university_id: this.changedDreamUniversity.university_id,
            outgoing_term_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
                .outgoing_term_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
			html: 'Do you want to change dream university?',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                that.optingOut = true;
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.CHANGE_DREAM_UNIVERSITY).subscribe(data => {
                        changeDreamUniversityResponse = data;
                        resolve(changeDreamUniversityResponse);
                    }, error => {
                        changeDreamUniversityResponse = error;
                        reject(changeDreamUniversityResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (changeDreamUniversityResponse.status === 'success') {
                    that.optingOut = false;
					that.toastr.success('Successfully changed dream university.', 'Success');
                    that.getRoundData();
                    that.closeModal();
                } else if (changeDreamUniversityResponse.status === 'fail') {
                    if (changeDreamUniversityResponse.hasOwnProperty('message') && changeDreamUniversityResponse.message !== '' &&
                        changeDreamUniversityResponse.message !== null && changeDreamUniversityResponse.message !== undefined) {
                        that.toastr.error(changeDreamUniversityResponse.message, 'Fail');
                    } else {
						that.toastr.error('Unable to change dream university, Please contact support team.', 'Fail');
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    optOutFromExchange() {
        const that = this;
        let optOutResponse;
        const body = {
            outgoing_student_id: JSON.parse(localStorage.getItem('epas_user')).roles[0].epas_user_role_mapping.student_id,
            outgoing_round_name_id: RoundNameConstants.CONFIRMATION_ROUND2,
            outgoing_round_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
                .outgoing_round_id,
            user_id: JSON.parse(localStorage.getItem('epas_user')).user_id,
            outgoing_term_id: JSON.parse(localStorage.getItem('epas_user')).term.rounds[RoundNameConstants.CONFIRMATION_ROUND2]
                .outgoing_term_id
        };
        Swal({
            type: 'question',
            title: 'Confirm',
            html: 'Do you want to <span style="font-weight: bold">Opt-out</span> from the' +
                ' <span style="font-weight: bold">Exchange Process</span>?<br>' +
                ' You will not be able to <span style="font-weight: bold">participate</span> in any <span style="font-weight: bold">' +
                'further rounds</span> and <span style="font-weight: bold">fine would be applicable as per conveyed by OIA</span>',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-outline-success rounded-0',
            cancelButtonClass: 'btn btn-outline-danger rounded-0',
            cancelButtonColor: '#d33',
            confirmButtonColor: '#5cb85c',
            cancelButtonText: 'No',
            confirmButtonText: 'Yes',
            showLoaderOnConfirm: true,
            preConfirm: function () {
                that.confirmedUniversity['opting_out'] = true;
                return new Promise(function (resolve, reject) {
                    that.dmService.javaPostDataCall(body, Constants.OPT_OUT_FROM_EXCHANGE).subscribe(data => {
                         optOutResponse = data;
                        resolve(optOutResponse);
                    }, error => {
                        optOutResponse = error;
                        reject(optOutResponse);
                    });
                });
            },
            allowOutsideClick: false
        }).then(function (result) {
            if (result.hasOwnProperty('value')) {
                if (optOutResponse.status === 'success') {
                    that.toastr.success('Successfully Opted-out from the Exchange Process.', 'Success');
                    that.getRoundData();
                } else if (optOutResponse.status === 'fail') {
                    if (optOutResponse.hasOwnProperty('message') && optOutResponse.message !== '' &&
                        optOutResponse.message !== null && optOutResponse.message !== undefined) {
                        that.toastr.error(optOutResponse.message, 'Fail');
                    } else {
                        that.toastr.error('Unable to opt-out from the exchange process, Please contact support team.', 'Fail');
                    }
                }
            }
        }, function (cancel) {
            console.log(cancel);
        }).catch(function (error) {
            console.log(error);
        });
    }

    ngOnInit() {
        this.getRoundData();
        this.getRoundTimings();
        if (this.utilService.term && this.utilService.getNextActiveRoundRouterLink() !== undefined) {
            this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
            this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
        }
        if (JSON.parse(localStorage.getItem('epas_user')).term !== null && this.utilService.term !== undefined) {
            if (this.utilService.term.hasOwnProperty('rounds') &&
                this.utilService.term.rounds.hasOwnProperty(RoundNameConstants.CONFIRMATION_ROUND2)) {
                this.isRoundExist = true;
                this.startTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].start_time)
                    .utcOffset('+05:30');
                this.startTimeStr = this.startTime.format('DD-MMM-YYYY, hh:mm A');
                this.endTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time).utcOffset('+05:30');
                this.endTimeStr = this.endTime.format('DD-MMM-YYYY, hh:mm A');
                this.finalEndTime = moment(this.utilService.term.rounds[RoundNameConstants.CONFIRMATION_ROUND2].end_time)
                    .utcOffset('+05:30').add(this.refID, 'seconds');
            }
        }
        this.route = this.router.url;
        this.roundSettingsTimer = setInterval(() => {
             if (this.route.indexOf('/confirmation/round-2') !== -1) {
                 this.refreshRoundSettings();
             }
             if (this.route.indexOf('/confirmation/round-2') === -1) {
                 clearInterval(this.roundSettingsTimer);
             }
         }, 30000);
        this.oneSecondTimer = setInterval(() => {
            if (this.utilService.term && this.utilService.getNextActiveRoundRouterLink() !== undefined) {
                this.activeRoundLink = this.utilService.getNextActiveRoundRouterLink().split('#')[0];
                this.activeRound = this.utilService.getNextActiveRoundRouterLink().split('#')[1];
            }
            this.refreshRoundSettings();
            if (this.route.indexOf('/confirmation/round-2') !== -1 && this.isRoundExist) {
                this.currentTime = moment(this.currentTime).utcOffset('+05:30').add({'seconds': 1});
                this.currentTimeStr = this.currentTime.format('DD-MMM-YYYY, hh:mm:ss A');
                this.inRandomTime = this.currentTime > this.endTime && this.currentTime <= this.finalEndTime;
                if (this.currentTime > this.finalEndTime) {
                    this.isRoundEnded = true;
                } else if (this.currentTime < this.startTime) {
                    this.isRoundYetToStart = true;
                    this.timeToStart = moment.duration(this.startTime - this.currentTime);
                } else {
                    if (!this.isDataFetched) {
                        this.getRoundData();
                        this.isDataFetched = true;
                    }
                    this.isRoundEnded = false;
                    this.isRoundYetToStart = false;
                    this.timeToEnd = moment.duration(this.endTime - this.currentTime);
                }
                this.isDataReady = true;
            }
            if (this.route.indexOf('/confirmation/round-2') === -1) {
                clearInterval(this.oneSecondTimer);
            }
        }, 1000);
    }

    ngOnDestroy() {
        clearInterval(this.oneSecondTimer);
        clearInterval(this.roundSettingsTimer);
    }

}
